const actionButton = {
  borderRadius: '8px',
  fontSize: '16px',
};

const ActionButtonSXColors = {
  disabled: {
    backgroundColor: '#97C2E9',
    color: '#2F84D3',
  },
  enabled: {
    backgroundColor: '#2A77BE',
    color: '#FFF',
  },
  ready: {
    backgroundColor: '#0EB868',
    color: '#FFF',
  },
  failed: {
    backgroundColor: '#d32f2f',
    color: '#FFF',
  },
};

export const ActionButtonSX = Object.entries(ActionButtonSXColors).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [key]: {
      ...actionButton,
      ...value,
      '&:disabled': value,
      '&:hover': value,
    },
  }),
  {},
);

export const getActionButtonSX = (sx, isDisabled, isReady, isFailed) => {
  if (isDisabled) {
    return sx.disabled;
  }
  if (isReady) {
    return sx.ready;
  }
  if (isFailed) {
    return sx.failed;
  }
  return sx.enabled;
};

export const getActionButtonDefaultSX = (isDisabled, isReady, isFailed) => {
  return getActionButtonSX(ActionButtonSX, isDisabled, isReady, isFailed);
};
